import {
  Button,
  HStack,
  IconButton,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Spacer,
  Text,
} from '@chakra-ui/react';

import { CloseCircleOutline as CloseCircle, useToast } from '@aslanpay/portal-common-lib';

import useInviteIndividuals from 'app/hooks/useInviteIndividuals';

import { InviteIndividualModalProps } from './types';

function InviteIndividualModal({
  selectedIndividuals,
  isOpen,
  onClose,
  onInvite,
}: InviteIndividualModalProps) {
  const toast = useToast();

  const title =
    selectedIndividuals.length > 1 ? 'Invite the selected employee(s)?' : 'Invite employee?';
  const description = selectedIndividuals.length > 1 ? 'the selected employees' : 'this employee';

  const { mutate: inviteIndividuals, isLoading: isInvitingIndividuals } = useInviteIndividuals({
    onSuccess: () => {
      const toastDescription = `${selectedIndividuals.length} ${
        selectedIndividuals.length > 1 ? 'employees were' : 'employee was'
      } successfully invited!`;

      toast({
        position: 'top-right',
        status: 'success',
        title: `Employee${selectedIndividuals.length > 1 ? 's' : ''} invited`,
        description: toastDescription,
      });

      onInvite();
      onClose();
    },
    onError: () => {
      const toastDescription =
        selectedIndividuals.length > 1 ? 'not all employees were' : 'the employee was not';

      toast({
        position: 'top-right',
        status: 'error',
        title: 'Something went wrong',
        description: `Sorry, ${toastDescription} invited. Please try again.`,
      });

      onClose();
    },
  });

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="lg" isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          <HStack>
            <Text as="h6">{title}</Text>
            <Spacer />
            <IconButton
              variant="link"
              icon={<CloseCircle boxSize="30px" />}
              aria-label="Close create new admin"
              onClick={onClose}
            />
          </HStack>
        </ModalHeader>
        <ModalBody>
          <Text color="brand.mutedPurple" textStyle="body">
            {`We will send a welcome email to ${description}, with a link to download the Aslan app and register.`}
          </Text>
        </ModalBody>
        <ModalFooter>
          <Spacer />
          <Button variant="outline" size="sm" onClick={onClose}>
            Cancel
          </Button>
          <Button
            size="sm"
            isLoading={isInvitingIndividuals}
            onClick={() => inviteIndividuals({ ids: selectedIndividuals })}
          >
            Yes, invite
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}

export default InviteIndividualModal;
